//Checking for reference, storing it to local if so.

/**
 * used only in this block
 * @param {String} parameterName
 * @returns {String|null}
 */
var findGetParameter = (parameterName) => {
  var result = null,
    tmp = [];
  var items = location.search.substr(1).split("&");
  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
};

$(document).ready(() => {
  var materef = "";
  if (typeof getCookie("mate_ref_id") === "string") {
    materef = "&ibo=" + getCookie("mate_ref_id");
  }
  if (typeof getCookie("mate_jaicon_id") === "string") {
    materef += "&jcon=666";
  }
  if (materef.length > 0) {
    $("a.choose-mobile-plan").each(function () {
      var oldUrl = $(this).attr("href");
      $(this).attr("href", oldUrl + materef);
    });
  }
});
